import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { DebugUtils } from "abweb/utils/DebugUtils";
import { LogUtils } from "abweb/utils/log/LogUtils";
/**
 * Support searching through a locale-ordered list of bundle maps for a resource
 */
export class ResourceBundle {
  // Ordered list of locales, each with its own corresponding bundle
  constructor(namespace) {
    _defineProperty(this, "_localeBundles", []);
    this.namespace = namespace;
  }

  //// Should only be called by NamespaceManager for override processing
  get localeBundles() {
    return this._localeBundles;
  }

  /** Note that addLocaleResources appends to current list, so should call addLocaleResources in the order desired
   * for the getResource invocations
   */
  addLocaleResources(locale, bundleMap) {
    // defensive check
    if (this.getBundleMap(locale) != null) {
      DebugUtils.logAndThrowError("Already added json bundle for locale: " + locale);
    }
    this._localeBundles.push({
      locale: locale,
      bundle: bundleMap
    });
  }
  getBundleMap(locale) {
    // Expected to be at most two localeBundles, so iterate
    for (const lb of this._localeBundles) {
      if (lb.locale === locale) {
        return lb.bundle;
      }
    }
    return null;
  }

  /**
   * @param key does not have namespace
   * @return resource, else null if key not found
   */
  getResource(key) {
    for (const localeBundle of this._localeBundles) {
      const res = localeBundle.bundle[key];
      if (res != null) {
        return res;
      }
    }
    return null;
  }

  /////// Override Processing ////

  setOverrideResource(locale, key, resource) {
    const nsKey = this.namespace + ":" + key; // use for logging and error messages only
    for (const lb of this._localeBundles) {
      if (locale === lb.locale) {
        if (lb.bundle[key] === undefined) {
          // I18N mtg: agreed that *new* props should NOT be defined via the override mechanism.
          DebugUtils.logAndThrowError(`Trying to override ${nsKey} but it does not exist for locale '${locale}'.`);
        }
        ResourceBundle.LOG.info(`Overriding resource ${nsKey} for locale ${locale}`);
        lb.bundle[key] = resource;
        return;
      }
    }
    DebugUtils.logAndThrowError(`Trying to override ${nsKey} but locale '${locale}' was not loaded in bundle.`);
  }
}
_defineProperty(ResourceBundle, "LOG", LogUtils.getLogger(__filename));
//# sourceMappingURL=ResourceBundle.js.map
